import React from "react";
import {Grid}from "@mui/material";

import Product from "./Product/Product";
import useStyles from './styles'



const Products = ({ products, onAddToCart }) => {
    const classes = useStyles();
    return (
        <main className={classes.content}>
            <div className={classes.toolbar}/>
        <Grid container direction="row"
  justifyContent="center"
  alignItems="center" spacing={2}>
           
            {products.map((product) => {
                return (
                <Grid item key={product.id} xs={12} sm={8} md={4} lg={3}> 
                    <Product product={product} onAddToCart={onAddToCart}/>
                </Grid>)
            })}
        </Grid>
    </main>
    )

}

export default Products